document.addEventListener("DOMContentLoaded", () => {
  $(".mini-step-item.active .step-title .toggle-btn").html(
    '<svg role="img" width="15" height="9" viewBox="0 0 15 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 8.41176L7.58824 1L14 8.41176" stroke="black"/></svg>'
  );
  $(".mini-step-item .step-title").click(function () {
    if ($(this).siblings(".step-dropdown").is(":hidden")) {
      $(this)
        .find(".toggle-btn")
        .html(
          '<svg role="img" width="15" height="9" viewBox="0 0 15 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 8.41176L7.58824 1L14 8.41176" stroke="black"/></svg>'
        );
    } else {
      $(this)
        .find(".toggle-btn")
        .html(
          '<svg role="img" width="15" height="10" viewBox="0 0 15 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 0.999856L7.58824 8.41162L14 0.999856" stroke="black"/></svg>'
        );
    }
    $(this).siblings(".step-dropdown").slideToggle();
  });
});
